import React from "react"
import logo from "../../../../../assets/images/crm-logo.png"
import {useFormik} from "formik"
import Input from "../../../../generic/dataEntry/Input/Input"
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux"
import {authSlice} from "../../../../../store/slices/authSlice"
import Button from "../../../../generic/buttons/Button"
import {useNavigate, useSearchParams} from "react-router-dom"
import classes from "./ResetPassword.module.scss"
import {resetUserPassword} from "../../../../../store/actions/authActions"

function ResetPassword() {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {error, isLoginProcess} = useAppSelector(state => state.auth)
  const [params] = useSearchParams()
  const uuid = params.get("uuid") || ""
  const recoveryToken = params.get("recoveryToken") || ""

  const {values, handleChange, handleSubmit} = useFormik({
    initialValues: {
      new_password: "",
      new_password_confirm: "",
      user_uuid: uuid,
      recoveryToken
    },
    enableReinitialize: true,
    onSubmit: async () => {
      const errors = []

      if (!values.new_password) {
        errors.push({field: "new_password", message: "Введите новый пароль"})
      }

      if (!values.new_password_confirm) {
        errors.push({field: "new_password_confirm", message: "Введите повтор нового пароля"})
      }

      if (values.new_password && values.new_password_confirm && values.new_password !== values.new_password_confirm) {
        errors.push({field: "password_mismatch", message: "Пароли не совпадают"})
      }

      if (!errors.length) {
        const resetSuccess = await dispatch(resetUserPassword(values))
        if (resetSuccess) {
          navigate("/")
        }
      } else {
        dispatch(authSlice.actions.fieldError(errors))
      }
    }
  })

  const inputChangeHandler = (e: React.ChangeEvent) => {
    handleChange(e)
    dispatch(authSlice.actions.clearFieldError(`password_mismatch`))
    const fieldName: any = e.target.getAttribute('name')

    if (error[fieldName]) {
      dispatch(authSlice.actions.clearFieldError(fieldName))
    }
  }

  const renderForm = uuid && recoveryToken &&
    <div className={classes.wrap}>
      <div className={classes.form}>
        <div className={classes.logo}><img src={logo} alt=""/></div>
        <h1 className={classes.form_title}>Смена пароля</h1>
        <form
          onSubmit={handleSubmit}
        >
          <div className={classes.form_field}>
            <Input
              type={"password"}
              value={values.new_password}
              onChange={(e: React.ChangeEvent) => {
                inputChangeHandler(e)
              }}
              name={"new_password"}
              label={"Новый пароль"}
              valid={!error.new_password}
              errorMessage={error.new_password}
              shouldValidate
              required
            />
          </div>
          <div className={classes.form_field}>
            <Input
              type={"password"}
              value={values.new_password_confirm}
              onChange={(e: React.ChangeEvent) => {
                inputChangeHandler(e)
              }}
              name={"new_password_confirm"}
              label={"Повторите новый пароль"}
              valid={!error.new_password_confirm}
              errorMessage={error.new_password_confirm}
              shouldValidate
              required
            />
          </div>
          {error.password_mismatch &&
            <div className={classes.form_password_mismatch}>Пароли не совпадают</div>
          }
          <div className={classes.form_bottom}>
            <Button
              type={'submit'}
              className={classes.form_submit}
              isLoading={isLoginProcess}
              disabled={isLoginProcess}
            >
              Войти
            </Button>
          </div>
        </form>
      </div>
    </div>

  const renderError = (!uuid || !recoveryToken) &&
    <div className={classes.link_error}>Неверная ссылка на смену пароля!</div>

  return(
    <>
      {renderForm}
      {renderError}
    </>
  )
}

export default ResetPassword